import * as React from 'react';
import { UIHeading4 } from '@cian/ui-kit';

import * as style from '../../style.css';
import { HeaderRow } from '../HeaderRow';

export interface IFloatingHeaderProps {
  title: string;
  /** Компактные карточки ЖК (по одной на колонку, индексы те же, что и у основной шапки). */
  columns: React.ReactNode[];
  isVisible: boolean;
  pinnedIndex: number | null;
  showAddButton: boolean;
  registerCell(id: string): (node: HTMLDivElement | null) => void;
  scrollerRef: React.Ref<HTMLDivElement>;
  onScroll: React.UIEventHandler<HTMLDivElement>;
}

export const FloatingHeader = ({
  title,
  columns,
  isVisible,
  pinnedIndex,
  showAddButton,
  registerCell,
  scrollerRef,
  onScroll,
}: IFloatingHeaderProps) => (
  <div className={isVisible ? style['floating-header-visible'] : style['floating-header']} data-testid="FloatingHeader">
    <div className={style['floating-title']}>
      <UIHeading4>{title}</UIHeading4>
    </div>
    <div
      ref={scrollerRef}
      className={style['floating-header-scroller']}
      data-testid="FloatingHeaderScroller"
      onScroll={onScroll}
    >
      <div className={style['table']}>
        <div className={style['floating-header-row']}>
          <HeaderRow
            floating
            columns={columns}
            pinnedIndex={pinnedIndex}
            registerCell={registerCell}
            showAddButton={showAddButton}
          />
        </div>
      </div>
    </div>
  </div>
);
